import { createCircuitBreaker } from 'utils/createCircuitBreaker';
export const { crash, crash$, crashStatus, onCrash } = createCircuitBreaker();
